"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeaderRow = exports.ModalFooterRow = exports.ModalContainerWrapper = exports.ModalCloseButton = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _RowWithShadow = _interopRequireDefault(require("../helpers/RowWithShadow"));

var _button = require("../button");

var _context = require("../context");

var _layout = require("../layout");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ModalContainerWrapper = (0, _context.styledWithTheme)(_layout.Col)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    borderTopLeftRadius: selectors.radius(_constants.MODAL_BORDER_RADIUS),
    borderTopRightRadius: selectors.radius(_constants.MODAL_BORDER_RADIUS),
    width: '100%'
  };
});
exports.ModalContainerWrapper = ModalContainerWrapper;
var ModalCloseButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    position: 'absolute',
    right: '32px',
    color: selectors.color(_constants.MODAL_CLOSE_BUTTON_COLOR),
    ':hover, :active, :focus-visible': {
      borderColor: selectors.color(_constants.MODAL_CLOSE_BUTTON_COLOR)
    }
  };
});
exports.ModalCloseButton = ModalCloseButton;
var ModalFooterRow = (0, _context.styledWithTheme)(_RowWithShadow.default)(function (_ref3) {
  var hasShadow = _ref3.hasShadow,
      selectors = _ref3.theme.selectors;
  var stickyStyles = {
    position: 'sticky',
    bottom: 0,
    zIndex: 1
  };
  return _objectSpread({
    gridGap: selectors.space(_constants.FOOTER_SPACING),
    alignItems: 'center',
    justifyContent: 'flex-end'
  }, hasShadow && stickyStyles);
});
exports.ModalFooterRow = ModalFooterRow;
var ModalHeaderRow = (0, _context.styledWithTheme)(_RowWithShadow.default)(function (_ref4) {
  var hasShadow = _ref4.hasShadow;
  var stickyStyles = {
    position: 'sticky',
    top: 0,
    zIndex: 1
  };
  return _objectSpread({
    position: 'relative',
    alignItems: 'center'
  }, hasShadow && stickyStyles);
});
exports.ModalHeaderRow = ModalHeaderRow;